export default __webpack_public_path__ + "static/Beatrice-58180881720f5de00ebda54d9a47e018.png";